(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/match-list-item.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/match-list-item.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.MatchListItem = Backbone.Marionette.View.extend({
    tagName: 'li',
    className:
      'list-group-item maltipset-match-row row js-clickable2 clickable-list-group-item-default',
    modelEvents: {
      'change tipsInfoDataSet': 'render'
    },
    events: {
      click: 'matchClicked'
    },

    template: function(data) {
      return svs.maltipset.templates.match_list_item(data);
    },

    onRender: function() {
      if (!svs.core.detect.formfactor.mobile()) {
        this.$el.toggleClass(
          'selected',
          !_.isUndefined(this.model.get('isSelected')) &&
            this.model.get('isSelected') === true
        );
      }
    },

    matchClicked: function() {
      if (
        !svs.core.detect.formfactor.mobile() &&
        this.model.collection.matchChangeEnabled
      ) {
        this.model.collection.matchClicked(this.model);
      } else if (svs.core.detect.formfactor.mobile()) {
        window.location.href =
          '/sportservice/match/' + this.model.get('match').matchId;
      }
    }
  });
})(Backbone, _, svs);

 })(window);